import { render, staticRenderFns } from "./quotalogs.vue?vue&type=template&id=56917f3f&"
import script from "./quotalogs.vue?vue&type=script&lang=js&"
export * from "./quotalogs.vue?vue&type=script&lang=js&"
import style0 from "./quotalogs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports